import { Divider, makeStyles, Toolbar, Typography } from "@material-ui/core";
import React from "react";
import Flaticon from "./Flaticon";

const useStyles = makeStyles(theme => ({
  textFormatted: {
    whiteSpace: "pre-line"
  },
  header: { paddingLeft: "1rem" },
  icon: {
    width: "3rem",
    height: "3rem",
    fill: theme.palette.primary.main
  }
}));

const Header = ({ icon, title, helper }) => {
  const classes = useStyles();

  const Icon = icon;

  return (
    <>
      <Toolbar>
        {typeof icon === "string" ? (
          <Flaticon icon={icon} fontSize="3rem" color="primary" />
        ) : (
          <Icon className={classes.icon} />
        )}
        <Typography className={classes.header} variant="h4">
          {title}
        </Typography>
      </Toolbar>
      {helper && (
        <Toolbar>
          <Typography variant="body2" className={classes.textFormatted}>
            {helper}
          </Typography>
        </Toolbar>
      )}
      <Divider />
    </>
  );
};

export default Header;
